import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { LangBitmapFontTextShadowView } from 'src/lib/ui/components/LangBitmapFontTextShadowView';
import i18n from 'src/lib/i18n/i18n';
import StreakGlare from './StreakGlare';
import LangBitmapFontTextView, {
  LangBitmapOpts,
} from 'src/lib/ui/components/LangBitmapFontTextView';
import { parseAmount } from 'src/lib/utils';
import { user } from 'src/StateObserver';
import { getStreakBattleRoyaleRewardGemsPool } from 'src/replicant/streakbattleroyale/streakbattleroyale.getters';

const assets = {
  platform: 'assets/ui/match2/streakbattleroyaleV2/matching/platform.png',
  chest: 'assets/ui/match2/streakbattleroyaleV2/chest.png',
  bubble: 'assets/ui/match2/streakbattleroyaleV2/fujiquest-bubble.png',
};

export default class StreakChest extends View {
  private glare: StreakGlare;

  constructor(opts: ViewOpts) {
    super(opts);

    // Glare VFX
    this.glare = new StreakGlare({
      superview: this,
      opacity: 0.1,
      scale: 1,
      x: -7,
      y: -68,
    });

    // Chest
    new ImageScaleView({
      superview: this,
      image: assets.chest,
      scale: 0.85,
      width: 190,
      height: 214,
      x: -4,
      y: -68,
      centerOnOrigin: true,
    });

    // Speech bubble
    const panel = new ImageScaleView({
      superview: this,
      image: assets.bubble,
      width: 204,
      height: 145,
      x: -112,
      y: -150,
      centerOnOrigin: true,
    });

    const baseOpts: LangBitmapOpts = {
      superview: panel,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
    };

    // Prize label
    new LangBitmapFontTextShadowView({
      ...baseOpts,
      textShadowColor: '#8B1717',
      textShadowOpacity: 0.25,
      textShadowOffsetX: 0,
      textShadowOffsetY: 3,
      color: '#FFFFFF',
      font: 'Title',
      localeText: () => i18n('match2.streakBattleRoyale.popup.prizeV2'),
      size: 21,
      x: panel.style.width * 0.5 - 2,
      y: 5,
    });

    // Prize value
    new LangBitmapFontTextView({
      ...baseOpts,
      color: '#266887',
      font: 'Body',
      localeText: () =>
        parseAmount(getStreakBattleRoyaleRewardGemsPool(user())),
      size: 27,
      x: panel.style.width * 0.5 + 25,
      y: 47,
    });
  }

  public stopAnimation() {
    this.glare.stopAnimation();
  }
}
